module.exports = __webpack_public_path__ + "dist/img/default-item.a35d0e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/default-item.jpg
// module id = 80wS
// module chunks = 1